module.exports = __webpack_public_path__ + "img/girl-krug.027c5f5e.png";